export default __webpack_public_path__ + "/dist/images/logo1.ef7741f3124da1ca77d3a72c04a3facc.jpg";